
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface RendererAPI
 * @hideconstructor
 * @classdesc API class that is used to render dashboard content.
 * @example content.getFeature('Renderer')
 */
define([], () => {
	class RendererAPI {

		/**
		 * @function RendererAPI#render
		 * @description Renders the content at the provided domNode. StateAPI can be used to wait for completion.
		 * @param {HTMLElement} domNode Specifies where the content is rendered
		 * @example await content.getFeature('Renderer').render(domNode);
		 */
		render() {}

		/**
		 * @function RendererAPI#destroy
		 * @description Destroys the view and removes event listeners.
		 */
		destroy() {}
	}


	return RendererAPI;
});
